
import { getCar } from "../model/car";

export const getCarDetail = (ex) => {
	return {
		type: "GET_CAR_DETAIL",
		payload: getCar(ex)
	}
}